module.exports = __webpack_public_path__ + "static/media/de_overpass.051165f4.jpg";